import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdownWithAnchors from '@/components/VueMarkdownWithAnchors.vue';
import Loading from '@/components/Loading.vue';
const blobsModule = namespace('blobs');
let HandbookChapter = class HandbookChapter extends Vue {
    constructor() {
        super(...arguments);
        this.chapterMap = {
            introduction: 'Introduction',
            whatsDifferent: 'Whats Different',
            stepByStep: 'Step-By-Step Characters',
            species: 'Species',
            classes: 'Classes',
            backgrounds: 'Personality and Backgrounds',
            equipment: 'Equipment',
            customization: 'Customization Options',
            abilityScores: 'Using Ability Scores',
            adventuring: 'Adventuring',
            combat: 'Combat',
            casting: 'Force- and Tech-casting',
            conditions: 'Appendix A: Conditions',
            variantRules: 'Appendix B: Recommended Variant Rules',
            changelog: 'Changelog'
        };
    }
    created() {
        this.fetchHandbookBlob(this.blobName);
    }
    fetchData() {
        this.fetchHandbookBlob(this.blobName);
    }
    get title() {
        return this.chapterMap[this.chapter] + ' | PHB' + Vue.prototype.$titleSuffix;
    }
    get blobName() {
        return this.chapterMap[this.chapter];
    }
    get blob() {
        const blob = this.handbookBlobs[this.blobName];
        return blob && blob.replace(/\ufffd/g, '-');
    }
};
__decorate([
    blobsModule.State
], HandbookChapter.prototype, "handbookBlobs", void 0);
__decorate([
    blobsModule.Action
], HandbookChapter.prototype, "fetchHandbookBlob", void 0);
__decorate([
    Prop(String)
], HandbookChapter.prototype, "chapter", void 0);
__decorate([
    Watch('$route')
], HandbookChapter.prototype, "fetchData", null);
HandbookChapter = __decorate([
    Component({
        components: {
            VueMarkdownWithAnchors,
            Loading
        }
    })
], HandbookChapter);
export default HandbookChapter;
